import { API } from "@/lib/api";

// Streams an assistant reply over SSE. Cookies are sent for same-origin auth.
export async function streamChat(
  { session_id, message, mode = "general", dap_id = null, model = "claude" },
  { onDelta, onDone, onError } = {}
) {
  try {
    const res = await fetch(`${API}/assistant/chat`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json", "X-Dap-Csrf": "1" },
      body: JSON.stringify({ session_id, message, mode, dap_id, model }),
    });
    if (!res.ok || !res.body) {
      onError && onError("Assistant unavailable");
      onDone && onDone();
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buf = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buf += decoder.decode(value, { stream: true });
      let idx;
      while ((idx = buf.indexOf("\n\n")) >= 0) {
        const chunk = buf.slice(0, idx);
        buf = buf.slice(idx + 2);
        const line = chunk.replace(/^data: /, "").trim();
        if (!line) continue;
        try {
          const obj = JSON.parse(line);
          if (obj.delta) onDelta && onDelta(obj.delta);
          else if (obj.error) onError && onError(obj.error);
          else if (obj.done) {
            onDone && onDone();
            return;
          }
        } catch (e) {
          // Non-JSON keep-alive/comment lines are expected; ignore quietly.
        }
      }
    }
    onDone && onDone();
  } catch (e) {
    onError && onError(String(e));
    onDone && onDone();
  }
}
